export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Đăng nhập",
    "login.form.hint.user": "Thông tin đăng nhập",
    "login.form.hint.password": "Mật khẩu",
    "login.form.checkbox.remember-me": "Ghi nhớ tôi",
    "login.form.button.sign-in": "Đăng nhập",
    "login.form.message.invalid-user-credentials": "Thông tin đăng nhập hoặc mật khẩu không chính xác",
    "login.form.message.account-temporarily-locked": "Tài khoản của bạn tạm thời bị khóa, hãy quay lại sau 5 phút",
    "login.form.message.user-required": "Nhập thông tin đăng nhập",
    "login.form.message.password-required": "Nhập mật khẩu",
    "login.form.button.forgot-password": "Quên mật khẩu?",
    "error.mfa-required.title": "Thiết lập 2FA",
    "error.mfa-required.message1": "Xác thực hai yếu tố (2FA) là bắt buộc để bảo vệ tài khoản của bạn.",
    "error.mfa-required.message2": "Bạn sẽ được chuyển hướng đến tùy chọn cài đặt tài khoản của mình trong Bảng thông tin trực tuyến. Bật 2FA, làm theo hướng dẫn thiết lập, rồi quay lại đây.",
    "error.mfa-required.learnMore": "Tìm hiểu thêm về 2FA",
    "error.mfa-required.continue": "Tiếp tục",
    "error.root-admin-login.title": "Lỗi 403 - bị cấm",
    "error.root-admin-login.message": "Bạn đang đăng nhập với tư cách Quản trị viên Chỉ đọc. Để truy cập bảng điều khiển Web Recovery, vui lòng đăng nhập với tư cách người dùng đối tượng thuê khách hàng hoặc quản trị viên",
    "error.server-busy.message": "Máy chủ đang bận, vui lòng thử lại sau.",
    "error.network-connection.title": "Lỗi kết nối mạng",
    "error.network-connection.message": "Hãy kiểm tra kết nối internet của bạn rồi thử lại.",
    "error.internal-server-error.title": "Lỗi máy chủ nội bộ",
    "error.internal-server-error.message": "Để giải quyết lỗi, hãy liên hệ với bộ phận hỗ trợ và thông báo chi tiết lỗi:",
    "error.internal-server-error.copy.button": "Sao chép"
};
